import { Controller } from "stimulus"

export default class extends Controller {

	static targets = ['dowCheckbox', 'courseTypeCheckbox'];

	updateDowSelection() {
		let days = []
		this.dowCheckboxTargets.forEach( (e) => {
			if(e.checked) {
				days.push(e.dataset.day)
			}
		} )
		document.cookie = "dow_selection=" + JSON.stringify(days) + "; path=/"

		// don't relaod the page if we are at the category index, as we're not
		// refreshing the categories list here - just storing the user's choice in cookie
		if(!/categories\/?$/.test(window.location.pathname)) {
			Turbolinks.visit(window.location)
		}
	}

	clearDowSelection() {
		document.cookie = "dow_selection=[]; path=/"
		// don't relaod the page if we are at the category index, as we're not
		// refreshing the categories list here - just storing the user's choice in cookie
		Turbolinks.visit(window.location)
	}

	updateCourseTypeSelection() {
		let courseTypes = []
		this.courseTypeCheckboxTargets.forEach( (e) => {
			if(e.checked) {
				courseTypes.push(e.dataset.courseType)
			}
		} )
		document.cookie = "course_type_selection=" + JSON.stringify(courseTypes) + "; path=/"

		// don't relaod the page if we are at the category index, as we're not
		// refreshing the categories list here - just storing the user's choice in cookie
		if(!/categories\/?$/.test(window.location.pathname)) {
			Turbolinks.visit(window.location)
		}
	}

	clearCourseTypeSelection() {
		document.cookie = "course_type_selection=[]; path=/"
		// don't relaod the page if we are at the category index, as we're not
		// refreshing the categories list here - just storing the user's choice in cookie
		Turbolinks.visit(window.location)
	}

}
